import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import jspdf from 'jspdf';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { PopoverController } from '@ionic/angular';
import { OpcionesExportarComponent } from 'src/app/componentes/opciones-exportar/opciones-exportar.component';

@Component({
  selector: 'app-estados-cuenta',
  templateUrl: './estados-cuenta.component.html',
  styleUrls: ['./estados-cuenta.component.scss'],
})
export class EstadosCuentaComponent implements OnInit {
  Documentos = []
  Hijos = []

  HijosSeleccionados = []

  @Input() DocEstudiante = []
  @Input() FechaInicial = ""
  @Input() FechaFinal = ""
   Datos(val: Array<any>) {
    if (val.length > 0) {
      for (let i in val) {
        val[i].Primera = val[i].Documentos.splice(0, 1)
      }
    }

    this.Documentos = val
  }

  TieneVisible(arreglo) {
    for (let i of arreglo.Documentos) {
      if (this.EnArreglo(i.IdEstudiante, this.HijosSeleccionados)) {
        return true;
      }
    }
    return false;
  }

  @Input() set DatosEstudiante(val: Array<any>) {

    if (val.length > 0) {
      for (let i in val) {
        if (val[i].TipoDoc == 'A' || val[i].TipoDoc == 'B' || val[i].TipoDoc == 'R') {
          val[i].Concepto2 = ''
        } else {
          if (val[i].Documento.substring(0, 2) == 'IN') {
            val[i].Concepto2 = 'Registro Inscripción Año Escolar ' + val[i].PeriodoEscolar
          } else if (val[i].Documento.substring(0, 2) == 'RI') {
            if (val[i].BalDoc == 0) {
              val[i].Concepto2 = 'Saldo de Inscripción. Documento: ' + val[i].DocAfectado
            } else {
              val[i].Concepto2 = 'Abono de Inscripción. Documento: ' + val[i].DocAfectado
            }
          }
          else if (val[i].Documento.substring(0, 2) == 'NC') { val[i].Concepto2 = 'NC a Doc: ' + val[i].DocAfectado + ' ' + val[i].Concepto.substring(0, 40) }
          else {
            val[i].Concepto2 = val[i].Concepto.substring(0, 50)
          }
        }
      }
      this.DocEstudiante = val
    }

  }

  @Output() getEstadoEstudiante = new EventEmitter();
  @Output() desabilitar = new EventEmitter();
  disabled: boolean=true;

  resumen: boolean = false;
  estudiantes: boolean = false;
  @Output() correo = new EventEmitter();

  constructor(private conexion: ConexionService, private utilidades: UtilidadesService,
    private popoverController: PopoverController) { }

  Fecha = { Fecha1: "", Fecha2: "" }

  @Input() UserID = ""
  HijosSelect = []
  @ViewChild('pdfTable') pdfTable: ElementRef;
  pdf: string = ""


  getEstEstudiante(id) {
    this.getEstadoEstudiante.emit(id)
  }

  ngOnInit() {
    setTimeout(() => {
      this.HayDatos()
    }, 15000);
    this.Hijos = []
    for (let i of this.Hijos) {
      this.HijosSeleccionados.push(i.Id)
    }

    // for (let i of this.Hijos) {
    //   this.HijosSelect.push({ Nombre: i.Nombre1 + " " + i.Apellido1, Foto: i.Url, Value: i.Id })
    // }

    setTimeout(() => {
      this.getEstadosCuenta()
    }, 100);
  }

  EnArreglo(valor, arreglo) {
    for (let i of arreglo) {
      if (Number(valor) == Number(i)) {
        return true;
      }
    }

    return false;
  }

  Sumar(arreglo, columna):number {
    let total = 0;
    for (let i of arreglo) {
      total += Number(i[columna])
    }

    return total
  }

  async Exportar(e: Event) {
    const popover = await this.popoverController.create({
      component: OpcionesExportarComponent,
      event: e,
    });
    await popover.present();
    const { data } = await popover.onDidDismiss();
    this.utilidades.Depuracion(data, "console", "")
    if (data == "pdf") {
      this.pdfF()
    } else if (data == "excel") {
      this.exportexcel()
    }
  }

  BalanceAnterior(id) {
    let bAnterior = Number(String(document.getElementById(id).innerText).replace("RD$ ", "").replace(",", "").replace(",", "").replace(",", ""))
    return bAnterior
  }


  Imprimir() {

    let vent = window.open('', '', 'height=800, width=800');
    vent.document.write(this.TextoMostrable())
    vent.document.close()
    setTimeout(() => {
      vent.print()
    }, 300);

  }

  TextoMostrable() {
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title> </title> <style>  *{font-family: "Arial", sans-serif !important; letter-spacing: 0.1px;} .h3{margin: 1px 2px 2px 2px; font-size: 18px; font-weight: 800;}  table{ border-collapse:separate; width: 100%; table-layout: fixed;} th { padding: 5px 10px; }  .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 15px;} .table_header th:last-child{ border-right: 1px solid black; border-top-right-radius: 5px !important; border-bottom-right-radius: 5px !important; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px !important; border-bottom-left-radius: 5px !important; }  .thImp{padding: 7px 10px; font-size: 15px; text-align: center; width:90px !important;} .thImpC{padding: 7px 10px; font-size: 15px; text-align: center; width:220px !important;} .tdImp{ text-align: left; font-size: 15px; width: 90px !important;} .tdImpR{ text-align: right; font-size: 15px; width: 90px !important;} .tdImpC{ text-align: left; font-size: 15px; width: 220px !important;}  td{ text-align: left; font-size: 15px;} .tdFam{text-align: left; font-size: 15px; font-weight: bold;} .tdcantdocs{ padding: 5px 0; border-bottom: 2px solid black; border-top: 2px solid black; text-align: center; font-size: 15px;} </style> </head> <body> <div style="text-align: center; font-family: "Arial", sans-serif !important;"> <h3 class="h3"><b>INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </b></h3> <p style="font-size: 15px; margin: 3px 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 18px !important; margin-top: 15px;"> <b> Estados de cuentas al {{Fecha}} </b> </p>  </div>  {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML).replace("{{Fecha}}", this.Fecha.Fecha1)
  }

  
  TextoMostrablePDF() {
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title> </title> <style>  *{font-family: "Arial", sans-serif !important; letter-spacing: 0.1px;} .h3{margin: 1px 2px 2px 2px; font-size: 11px; font-weight: 800;}  table{ border-collapse:separate; width: 100%; table-layout: fixed;} th { padding: 5px 10px; }  .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 9px !important;} .table_header th:last-child{ border-right: 1px solid black; border-top-right-radius: 5px !important; border-bottom-right-radius: 5px !important; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px !important; border-bottom-left-radius: 5px !important; }  .thImp{padding: 7px 10px; font-size: 9px !important; text-align: center; width: 72px !important;} .thImpC{padding: 7px 10px; font-size: 9px !important; text-align: center; width: 130px !important;} .tdImp{ text-align: left; font-size: 9px !important; width:  72px !important;} .tdImpR{ text-align: right; font-size: 9px !important; width:  72px !important;} .tdImpC{ text-align: left; font-size: 9px !important; width: 130px !important;}  td{ text-align: left; font-size: 9px !important;} .tdFam{text-align: left; font-size: 9px !important; font-weight: bold;} .tdcantdocs{ padding: 5px 0; border-bottom: 2px solid black; border-top: 2px solid black; text-align: center; font-size: 9px !important;} </style> </head> <body> <div style="text-align: center; font-family: "Arial", sans-serif !important;"> <h3 class="h3"><b>INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </b></h3> <p style="font-size: 9px !important; margin: 3px 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 11px !important; margin-top: 11px;"> <b> Estados de cuentas al {{Fecha}} </b> </p>  </div>  {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML).replace("{{Fecha}}", this.Fecha.Fecha1)
  }

  exp = "TablaExportar"
  excel=false
  exportexcel(): void {
    this.exp = ""
    this.excel=true
    this.utilidades.Toast("Descargando Excel...", 3000, "download-outline")
    setTimeout(() => {
      /* table id is passed over here */
      // let element = document.getElementById('datos');
      // const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      // /* generate workbook and add the worksheet */
      // const wb: XLSX.WorkBook = XLSX.utils.book_new();
      // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // /* save to file */
      // XLSX.writeFile(wb, "Estados de cuenta " + String(new Date()) + ".xlsx");

      const downloadLink = document.createElement("a");
      const dataType = 'application/vnd.ms-excel';
      const table = document.getElementById("datos");
      const tableHtml = table.outerText.replace(/ /g, '%20')
      document.body.appendChild(downloadLink);
      downloadLink.href = 'data:' + dataType + ' ' + tableHtml;
      downloadLink.download = "Estados de cuenta " + String(new Date()) + ".xls";
      downloadLink.click();

      this.exp = "TablaExportar"
      this.excel=false
    }, 150);
  }

  getEstadosCuenta() {
    this.utilidades.Loading("Cargando documentos")
    this.conexion.getEstadosCuenta(this.UserID,
      this.Fecha.Fecha1, this.Fecha.Fecha2).subscribe((resp) => {
        this.desabilitar.emit(false)
        this.disabled=false;
        this.utilidades.CerrarLoading()
        this.utilidades.Depuracion(resp, "console", "")
        if (resp.Respuesta == "Exito") {
          this.Datos(resp.Datos)
          this.utilidades.Depuracion(resp.Datos, "console", "")
        }
      }, (err) => {
        this.utilidades.CerrarLoading()
        this.utilidades.Alerta("En estos momentos este servicio no se encuentra disponible. Por favor, inténtelo más tarde.")
        this.desabilitar.emit(true)
        this.disabled=true;
        this.utilidades.ValidarUser(err)
      })
  }


  pdfF(){
    this.utilidades.Toast("Descargando PDF...", 3000, "download-outline")
    let d = document.getElementById("imprimible")
    d.innerHTML = this.TextoMostrablePDF()
    this.pdf="pedefeable"
    document.getElementById("cc").scrollTo({ top: 0, behavior: "smooth" })

    setTimeout(() => {
      let pd = new jspdf('p', 'pt', 'a4')
    pd.html(this.pdfTable.nativeElement,{ "margin":[25, 0, 25, 0], callback: (pdf) =>{
      pdf.save("Documentos pendientes  " + String(new Date()) +".pdf")
      setTimeout(() => {
        d.innerHTML = ""
        this.pdf = ""
      }, 800);
    }})
    }, 100);
    
  }

  HayDatos(): boolean {
    if (document.getElementById("datos")) {
      if (document.getElementById("datos").innerText.length > 60) {
        return true;
      }
    }
    return false;
  }
}
